import {generateRandomId} from 'utils';

function updateCartCountElements(itemCount) {
  const cartItemCountElements = document.querySelectorAll('[data-item-count]');

  cartItemCountElements.forEach((element) => {
    element.setAttribute('data-item-count', itemCount);
  });
}

async function getCart() {
  try {
    const response = await fetch(window.routes.cart_url);
    if (!response.ok) throw new Error();

    const cart = await response.json();
    if (!cart) throw new Error();

    updateCartCountElements(cart.item_count);

    // Generic event - Used to update data like cart count etc..
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
        },
      })
    );

    return cart;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function manageCartOperations(url, event, formElement) {
  const form = formElement || event.target;
  if (!form) throw new Error();

  // Not enough support yet for event.submitter
  const button = event.submitter || form.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g., sticky button)

  button?.classList.add('loading');

  const formData = new FormData(form);

  // Generate a unique id for each item to ensure it is added as a separate line item in the cart.
  if (!formData.has('properties[_unique_id]')) {
    formData.append('properties[_unique_id]', generateRandomId());
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) throw new Error();

    const data = await response.json();
    if (!data) throw new Error();

    await getCart();

    button?.classList.remove('loading');
    window.theme.modals.cart.open();

    return data;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function manageSerializedDataOperations(url, event, serializedData) {
  const form = event.target.closest('form');
  if (!form) throw new Error();

  // Not enough support yet for event.submitter
  const button = event.submitter || form.querySelector('button[name="add"]:focus'); // :focus to support multiple buttons in the same form (e.g., sticky button)

  button?.classList.add('loading');

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializedData,
    });
    if (!response.ok) throw new Error();

    const data = await response.json();
    if (!data) throw new Error();

    await getCart();

    button?.classList.remove('loading');
    window.theme.modals.cart.open();

    return data;
  } catch (error) {
    console.error(error.message);

    return {};
  }
}

async function addToCart(event) {
  event.preventDefault();

  const url = window.routes.cart_add_url;
  await manageCartOperations(url, event);
}

async function addSerializedDataToCart(event, serializedData) {
  event.preventDefault();

  const url = window.routes.cart_add_url;
  await manageSerializedDataOperations(url, event, serializedData);
}

function updateItem(event, form) {
  event.preventDefault();

  const url = window.routes.cart_update_url;
  manageCartOperations(url, event, form);
}

// To change the quantity, properties
async function changeItem(event, formData) {
  event.preventDefault();

  const url = window.routes.cart_change_url;
  await manageCartOperations(url, event, formData);
}

function removeItem(event) {
  event.preventDefault();

  const url = window.routes.cart_change_url;
  manageCartOperations(url, event);
}

export {getCart, addToCart, addSerializedDataToCart, changeItem, updateItem, removeItem};
